import intl from "react-intl-universal";

export default class Translations {

  static get(key) {
    return intl.get(key).d(key);
  }

}
